/* tslint:disable */
/* eslint-disable */
/**
 * BestShot API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BotModel
 */
export interface BotModel {
    /**
     * 
     * @type {string}
     * @memberof BotModel
     */
    'id': string;
    /**
     * Human-readable bot model title
     * @type {string}
     * @memberof BotModel
     */
    'title': string;
    /**
     * Human-readable bot model description
     * @type {string}
     * @memberof BotModel
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof BotModel
     */
    'max_context_files': number;
    /**
     * 
     * @type {number}
     * @memberof BotModel
     */
    'max_context_folders': number;
}
/**
 * 
 * @export
 * @interface ContextFoldersButtons
 */
export interface ContextFoldersButtons {
    /**
     * 
     * @type {string}
     * @memberof ContextFoldersButtons
     */
    'title': string;
    /**
     * Unique identifier of a document folder
     * @type {string}
     * @memberof ContextFoldersButtons
     */
    'context_folder_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ContextFoldersButtons
     */
    'default': boolean;
}
/**
 * 
 * @export
 * @interface CurrentUser
 */
export interface CurrentUser {
    /**
     * Unique identifier of a user
     * @type {string}
     * @memberof CurrentUser
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUser
     */
    'is_authenticated': boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentUser
     */
    'full_name': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUser
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * Unique identifier of a document
     * @type {string}
     * @memberof Document
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'folder'?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface DocumentFolderPreview
 */
export interface DocumentFolderPreview {
    /**
     * Unique identifier of a document folder
     * @type {string}
     * @memberof DocumentFolderPreview
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentFolderPreview
     */
    'title': string;
    /**
     * Unique identifier of a document folder
     * @type {string}
     * @memberof DocumentFolderPreview
     */
    'parent_id': string;
}
/**
 * 
 * @export
 * @interface DocumentPassage
 */
export interface DocumentPassage {
    /**
     * Unique identifier of a document passage
     * @type {string}
     * @memberof DocumentPassage
     */
    'id': string;
    /**
     * 
     * @type {Document}
     * @memberof DocumentPassage
     */
    'document': Document;
    /**
     * Key of a document passage
     * @type {string}
     * @memberof DocumentPassage
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentPassage
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentPassage
     */
    'type': DocumentPassageTypeEnum;
    /**
     * 
     * @type {DocumentPassageNearVectorMetadata}
     * @memberof DocumentPassage
     */
    'near_vector_metadata'?: DocumentPassageNearVectorMetadata;
    /**
     * Source URL for the passage, if available
     * @type {string}
     * @memberof DocumentPassage
     */
    'source_url': string;
}

export const DocumentPassageTypeEnum = {
    CaseLaw: 'case_law',
    ClientHistory: 'client_history'
} as const;

export type DocumentPassageTypeEnum = typeof DocumentPassageTypeEnum[keyof typeof DocumentPassageTypeEnum];

/**
 * 
 * @export
 * @interface DocumentPassageNearVectorMetadata
 */
export interface DocumentPassageNearVectorMetadata {
    /**
     * 
     * @type {number}
     * @memberof DocumentPassageNearVectorMetadata
     */
    'score'?: number;
}
/**
 * 
 * @export
 * @interface DocumentPreview
 */
export interface DocumentPreview {
    /**
     * Unique identifier of a document
     * @type {string}
     * @memberof DocumentPreview
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentPreview
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentPreview
     */
    'folder'?: string;
    /**
     * Unique identifier of a document folder
     * @type {string}
     * @memberof DocumentPreview
     */
    'folder_id'?: string;
}
/**
 * 
 * @export
 * @interface ExternalLinkPreview
 */
export interface ExternalLinkPreview {
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreview
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreview
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreview
     */
    'preview_text': string;
}
/**
 * 
 * @export
 * @interface GetDocumentsAutocomplete200Response
 */
export interface GetDocumentsAutocomplete200Response {
    /**
     * 
     * @type {Array<DocumentPreview>}
     * @memberof GetDocumentsAutocomplete200Response
     */
    'documents'?: Array<DocumentPreview>;
    /**
     * 
     * @type {Array<DocumentFolderPreview>}
     * @memberof GetDocumentsAutocomplete200Response
     */
    'folders'?: Array<DocumentFolderPreview>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MessageFeedbackRating = {
    Like: 'like',
    Dislike: 'dislike'
} as const;

export type MessageFeedbackRating = typeof MessageFeedbackRating[keyof typeof MessageFeedbackRating];


/**
 * 
 * @export
 * @enum {string}
 */

export const MessageStatus = {
    Ready: 'ready',
    Pending: 'pending',
    Failed: 'failed'
} as const;

export type MessageStatus = typeof MessageStatus[keyof typeof MessageStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const MessageType = {
    User: 'user',
    Bot: 'bot'
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType];


/**
 * 
 * @export
 * @interface RequestCheckResetPasswordToken
 */
export interface RequestCheckResetPasswordToken {
    /**
     * 
     * @type {string}
     * @memberof RequestCheckResetPasswordToken
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface RequestCreateMessage
 */
export interface RequestCreateMessage {
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMessage
     */
    'text': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequestCreateMessage
     */
    'context_document_ids': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequestCreateMessage
     */
    'context_folder_ids': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMessage
     */
    'follow_links': boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMessage
     */
    'model': string;
}
/**
 * 
 * @export
 * @interface RequestFinishResetPassword
 */
export interface RequestFinishResetPassword {
    /**
     * 
     * @type {string}
     * @memberof RequestFinishResetPassword
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof RequestFinishResetPassword
     */
    'new_password'?: string;
}
/**
 * 
 * @export
 * @interface RequestGoogleAuthFinish
 */
export interface RequestGoogleAuthFinish {
    /**
     * OAuth2 state parameter returned by Google
     * @type {string}
     * @memberof RequestGoogleAuthFinish
     */
    'state': string;
    /**
     * Authorization code returned by Google
     * @type {string}
     * @memberof RequestGoogleAuthFinish
     */
    'code': string;
    /**
     * Granted scopes
     * @type {string}
     * @memberof RequestGoogleAuthFinish
     */
    'scope': string;
    /**
     * Index of the Google account used
     * @type {string}
     * @memberof RequestGoogleAuthFinish
     */
    'authuser': string;
    /**
     * Prompt parameter returned by Google
     * @type {string}
     * @memberof RequestGoogleAuthFinish
     */
    'prompt': string;
}
/**
 * 
 * @export
 * @interface RequestMessageFeedback
 */
export interface RequestMessageFeedback {
    /**
     * Unique identifier of a chat
     * @type {string}
     * @memberof RequestMessageFeedback
     */
    'chat_id': string;
    /**
     * Unique identifier of a message
     * @type {string}
     * @memberof RequestMessageFeedback
     */
    'message_id': string;
    /**
     * 
     * @type {MessageFeedbackRating}
     * @memberof RequestMessageFeedback
     */
    'rating': MessageFeedbackRating;
    /**
     * 
     * @type {string}
     * @memberof RequestMessageFeedback
     */
    'comment': string;
}


/**
 * 
 * @export
 * @interface RequestPasswordSignIn
 */
export interface RequestPasswordSignIn {
    /**
     * 
     * @type {string}
     * @memberof RequestPasswordSignIn
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof RequestPasswordSignIn
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface RequestRefreshToken
 */
export interface RequestRefreshToken {
    /**
     * 
     * @type {string}
     * @memberof RequestRefreshToken
     */
    'refresh'?: string;
}
/**
 * 
 * @export
 * @interface RequestResetPassword
 */
export interface RequestResetPassword {
    /**
     * 
     * @type {string}
     * @memberof RequestResetPassword
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface RequestUpdateChat
 */
export interface RequestUpdateChat {
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateChat
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface ResponseAuthenticatedUser
 */
export interface ResponseAuthenticatedUser {
    /**
     * 
     * @type {CurrentUser}
     * @memberof ResponseAuthenticatedUser
     */
    'user': CurrentUser;
    /**
     * 
     * @type {TokenPair}
     * @memberof ResponseAuthenticatedUser
     */
    'tokens': TokenPair;
}
/**
 * 
 * @export
 * @interface ResponseChat
 */
export interface ResponseChat {
    /**
     * Unique identifier of a chat
     * @type {string}
     * @memberof ResponseChat
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ResponseChat
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof ResponseChat
     */
    'last_message_at': number;
}
/**
 * 
 * @export
 * @interface ResponseChatArray
 */
export interface ResponseChatArray {
    /**
     * 
     * @type {Array<ResponseChat>}
     * @memberof ResponseChatArray
     */
    'chats': Array<ResponseChat>;
}
/**
 * 
 * @export
 * @interface ResponseChatSharedLink
 */
export interface ResponseChatSharedLink {
    /**
     * Unique identifier of a chat shared link
     * @type {string}
     * @memberof ResponseChatSharedLink
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface ResponseChatSharedLinkArray
 */
export interface ResponseChatSharedLinkArray {
    /**
     * 
     * @type {Array<ResponseChatSharedLink>}
     * @memberof ResponseChatSharedLinkArray
     */
    'shared_links': Array<ResponseChatSharedLink>;
}
/**
 * 
 * @export
 * @interface ResponseCheckResetPasswordToken
 */
export interface ResponseCheckResetPasswordToken {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCheckResetPasswordToken
     */
    'is_valid': boolean;
    /**
     * 
     * @type {CurrentUser}
     * @memberof ResponseCheckResetPasswordToken
     */
    'user': CurrentUser | null;
}
/**
 * 
 * @export
 * @interface ResponseDocumentPassageExplorer
 */
export interface ResponseDocumentPassageExplorer {
    /**
     * 
     * @type {Document}
     * @memberof ResponseDocumentPassageExplorer
     */
    'document': Document;
    /**
     * 
     * @type {DocumentPassage}
     * @memberof ResponseDocumentPassageExplorer
     */
    'passage': DocumentPassage;
    /**
     * 
     * @type {Array<DocumentPassage>}
     * @memberof ResponseDocumentPassageExplorer
     */
    'previous_passages': Array<DocumentPassage>;
    /**
     * 
     * @type {Array<DocumentPassage>}
     * @memberof ResponseDocumentPassageExplorer
     */
    'next_passages': Array<DocumentPassage>;
    /**
     * 
     * @type {Array<DocumentPassage>}
     * @memberof ResponseDocumentPassageExplorer
     */
    'related_passages': Array<DocumentPassage>;
    /**
     * 
     * @type {Array<ExternalLinkPreview>}
     * @memberof ResponseDocumentPassageExplorer
     */
    'external_links': Array<ExternalLinkPreview>;
}
/**
 * 
 * @export
 * @interface ResponseFeatureSettings
 */
export interface ResponseFeatureSettings {
    /**
     * 
     * @type {ResponseFeatureSettingsChats}
     * @memberof ResponseFeatureSettings
     */
    'chats': ResponseFeatureSettingsChats;
    /**
     * 
     * @type {ResponseFeatureSettingsMessageFeedback}
     * @memberof ResponseFeatureSettings
     */
    'message_feedback'?: ResponseFeatureSettingsMessageFeedback;
}
/**
 * 
 * @export
 * @interface ResponseFeatureSettingsChats
 */
export interface ResponseFeatureSettingsChats {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseFeatureSettingsChats
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<BotModel>}
     * @memberof ResponseFeatureSettingsChats
     */
    'models': Array<BotModel>;
    /**
     * 
     * @type {Array<ContextFoldersButtons>}
     * @memberof ResponseFeatureSettingsChats
     */
    'context_folders_buttons': Array<ContextFoldersButtons>;
}
/**
 * 
 * @export
 * @interface ResponseFeatureSettingsMessageFeedback
 */
export interface ResponseFeatureSettingsMessageFeedback {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseFeatureSettingsMessageFeedback
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponseFeatureSettingsMessageFeedback
     */
    'comment_min_length': number;
    /**
     * 
     * @type {number}
     * @memberof ResponseFeatureSettingsMessageFeedback
     */
    'comment_max_length': number;
}
/**
 * 
 * @export
 * @interface ResponseGoogleAuthFinish
 */
export interface ResponseGoogleAuthFinish {
    /**
     * 
     * @type {ResponseGoogleAuthFinishUser}
     * @memberof ResponseGoogleAuthFinish
     */
    'user': ResponseGoogleAuthFinishUser;
    /**
     * 
     * @type {ResponseGoogleAuthFinishTokens}
     * @memberof ResponseGoogleAuthFinish
     */
    'tokens': ResponseGoogleAuthFinishTokens;
}
/**
 * 
 * @export
 * @interface ResponseGoogleAuthFinishTokens
 */
export interface ResponseGoogleAuthFinishTokens {
    /**
     * 
     * @type {string}
     * @memberof ResponseGoogleAuthFinishTokens
     */
    'access_token': string;
}
/**
 * 
 * @export
 * @interface ResponseGoogleAuthFinishUser
 */
export interface ResponseGoogleAuthFinishUser {
    /**
     * 
     * @type {string}
     * @memberof ResponseGoogleAuthFinishUser
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGoogleAuthFinishUser
     */
    'full_name': string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGoogleAuthFinishUser
     */
    'role': ResponseGoogleAuthFinishUserRoleEnum;
}

export const ResponseGoogleAuthFinishUserRoleEnum = {
    User: 'user',
    Guest: 'guest'
} as const;

export type ResponseGoogleAuthFinishUserRoleEnum = typeof ResponseGoogleAuthFinishUserRoleEnum[keyof typeof ResponseGoogleAuthFinishUserRoleEnum];

/**
 * 
 * @export
 * @interface ResponseGoogleAuthStart
 */
export interface ResponseGoogleAuthStart {
    /**
     * Google OAuth2 authorization URL to redirect the user to
     * @type {string}
     * @memberof ResponseGoogleAuthStart
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface ResponseMessage
 */
export interface ResponseMessage {
    /**
     * Unique identifier of a message
     * @type {string}
     * @memberof ResponseMessage
     */
    'id': string;
    /**
     * Unique identifier of a chat
     * @type {string}
     * @memberof ResponseMessage
     */
    'chat_id': string;
    /**
     * 
     * @type {MessageType}
     * @memberof ResponseMessage
     */
    'type': MessageType;
    /**
     * 
     * @type {string}
     * @memberof ResponseMessage
     */
    'text'?: string;
    /**
     * 
     * @type {MessageStatus}
     * @memberof ResponseMessage
     */
    'status': MessageStatus;
    /**
     * 
     * @type {Array<DocumentPreview>}
     * @memberof ResponseMessage
     */
    'context_documents'?: Array<DocumentPreview>;
    /**
     * 
     * @type {Array<DocumentFolderPreview>}
     * @memberof ResponseMessage
     */
    'context_folders'?: Array<DocumentFolderPreview>;
    /**
     * 
     * @type {Array<DocumentPreview>}
     * @memberof ResponseMessage
     */
    'related_documents'?: Array<DocumentPreview>;
    /**
     * 
     * @type {Array<DocumentPassage>}
     * @memberof ResponseMessage
     */
    'related_client_history_passages'?: Array<DocumentPassage>;
    /**
     * 
     * @type {Array<DocumentPassage>}
     * @memberof ResponseMessage
     */
    'related_case_law_passages'?: Array<DocumentPassage>;
    /**
     * 
     * @type {MessageFeedbackRating}
     * @memberof ResponseMessage
     */
    'rating': MessageFeedbackRating | null;
}


/**
 * 
 * @export
 * @interface ResponseMessageArray
 */
export interface ResponseMessageArray {
    /**
     * 
     * @type {Array<ResponseMessage>}
     * @memberof ResponseMessageArray
     */
    'messages': Array<ResponseMessage>;
    /**
     * 
     * @type {UserSettings}
     * @memberof ResponseMessageArray
     */
    'user_settings': UserSettings;
}
/**
 * 
 * @export
 * @interface ResponseMessagePair
 */
export interface ResponseMessagePair {
    /**
     * 
     * @type {ResponseMessage}
     * @memberof ResponseMessagePair
     */
    'user': ResponseMessage;
    /**
     * 
     * @type {ResponseMessage}
     * @memberof ResponseMessagePair
     */
    'bot': ResponseMessage;
}
/**
 * 
 * @export
 * @interface ResponseRefreshToken
 */
export interface ResponseRefreshToken {
    /**
     * 
     * @type {string}
     * @memberof ResponseRefreshToken
     */
    'access'?: string;
}
/**
 * 
 * @export
 * @interface TokenPair
 */
export interface TokenPair {
    /**
     * 
     * @type {string}
     * @memberof TokenPair
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof TokenPair
     */
    'refresh_token': string;
}
/**
 * 
 * @export
 * @interface UserSettings
 */
export interface UserSettings {
    /**
     * 
     * @type {string}
     * @memberof UserSettings
     */
    'bot_model': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettings
     */
    'follow_links': boolean;
    /**
     * 
     * @type {Array<DocumentPreview>}
     * @memberof UserSettings
     */
    'context_documents': Array<DocumentPreview>;
    /**
     * 
     * @type {Array<DocumentFolderPreview>}
     * @memberof UserSettings
     */
    'context_folders': Array<DocumentFolderPreview>;
}

/**
 * ChatSharedLinksApi - axios parameter creator
 * @export
 */
export const ChatSharedLinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a shared link for a chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatSharedLink: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('createChatSharedLink', 'chatId', chatId)
            const localVarPath = `/chats/{chatId}/shared-links`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a shared link
         * @param {string} chatId 
         * @param {string} sharedLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatSharedLink: async (chatId: string, sharedLinkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('deleteChatSharedLink', 'chatId', chatId)
            // verify required parameter 'sharedLinkId' is not null or undefined
            assertParamExists('deleteChatSharedLink', 'sharedLinkId', sharedLinkId)
            const localVarPath = `/chats/{chatId}/shared-links/{sharedLinkId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"sharedLinkId"}}`, encodeURIComponent(String(sharedLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List shared links
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChatSharedLinks: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('listChatSharedLinks', 'chatId', chatId)
            const localVarPath = `/chats/{chatId}/shared-links`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatSharedLinksApi - functional programming interface
 * @export
 */
export const ChatSharedLinksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatSharedLinksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a shared link for a chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChatSharedLink(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChatSharedLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChatSharedLink(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatSharedLinksApi.createChatSharedLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a shared link
         * @param {string} chatId 
         * @param {string} sharedLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChatSharedLink(chatId: string, sharedLinkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChatSharedLink(chatId, sharedLinkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatSharedLinksApi.deleteChatSharedLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List shared links
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listChatSharedLinks(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChatSharedLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listChatSharedLinks(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatSharedLinksApi.listChatSharedLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatSharedLinksApi - factory interface
 * @export
 */
export const ChatSharedLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatSharedLinksApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a shared link for a chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatSharedLink(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChatSharedLink> {
            return localVarFp.createChatSharedLink(chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a shared link
         * @param {string} chatId 
         * @param {string} sharedLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatSharedLink(chatId: string, sharedLinkId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteChatSharedLink(chatId, sharedLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List shared links
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChatSharedLinks(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChatSharedLink> {
            return localVarFp.listChatSharedLinks(chatId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatSharedLinksApi - object-oriented interface
 * @export
 * @class ChatSharedLinksApi
 * @extends {BaseAPI}
 */
export class ChatSharedLinksApi extends BaseAPI {
    /**
     * 
     * @summary Create a shared link for a chat
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatSharedLinksApi
     */
    public createChatSharedLink(chatId: string, options?: RawAxiosRequestConfig) {
        return ChatSharedLinksApiFp(this.configuration).createChatSharedLink(chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a shared link
     * @param {string} chatId 
     * @param {string} sharedLinkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatSharedLinksApi
     */
    public deleteChatSharedLink(chatId: string, sharedLinkId: string, options?: RawAxiosRequestConfig) {
        return ChatSharedLinksApiFp(this.configuration).deleteChatSharedLink(chatId, sharedLinkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List shared links
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatSharedLinksApi
     */
    public listChatSharedLinks(chatId: string, options?: RawAxiosRequestConfig) {
        return ChatSharedLinksApiFp(this.configuration).listChatSharedLinks(chatId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatsApi - axios parameter creator
 * @export
 */
export const ChatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChat: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('deleteChat', 'chatId', chatId)
            const localVarPath = `/chats/{chatId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a chat by ID
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChat: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('getChat', 'chatId', chatId)
            const localVarPath = `/chats/{chatId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of all chats of the current user
         * @summary List chats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a chat
         * @param {string} chatId 
         * @param {RequestUpdateChat} requestUpdateChat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChat: async (chatId: string, requestUpdateChat: RequestUpdateChat, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('updateChat', 'chatId', chatId)
            // verify required parameter 'requestUpdateChat' is not null or undefined
            assertParamExists('updateChat', 'requestUpdateChat', requestUpdateChat)
            const localVarPath = `/chats/{chatId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestUpdateChat, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatsApi - functional programming interface
 * @export
 */
export const ChatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChat(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChat(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.deleteChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a chat by ID
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChat(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChat(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.getChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of all chats of the current user
         * @summary List chats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listChats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChatArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listChats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.listChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a chat
         * @param {string} chatId 
         * @param {RequestUpdateChat} requestUpdateChat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChat(chatId: string, requestUpdateChat: RequestUpdateChat, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChat(chatId, requestUpdateChat, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.updateChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatsApi - factory interface
 * @export
 */
export const ChatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChat(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteChat(chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a chat by ID
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChat(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChat> {
            return localVarFp.getChat(chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of all chats of the current user
         * @summary List chats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChats(options?: RawAxiosRequestConfig): AxiosPromise<ResponseChatArray> {
            return localVarFp.listChats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a chat
         * @param {string} chatId 
         * @param {RequestUpdateChat} requestUpdateChat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChat(chatId: string, requestUpdateChat: RequestUpdateChat, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChat> {
            return localVarFp.updateChat(chatId, requestUpdateChat, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatsApi - object-oriented interface
 * @export
 * @class ChatsApi
 * @extends {BaseAPI}
 */
export class ChatsApi extends BaseAPI {
    /**
     * 
     * @summary Delete a chat
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public deleteChat(chatId: string, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).deleteChat(chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a chat by ID
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public getChat(chatId: string, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).getChat(chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of all chats of the current user
     * @summary List chats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public listChats(options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).listChats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a chat
     * @param {string} chatId 
     * @param {RequestUpdateChat} requestUpdateChat 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public updateChat(chatId: string, requestUpdateChat: RequestUpdateChat, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).updateChat(chatId, requestUpdateChat, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a document by its unique identifier
         * @summary Get a document by ID
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getDocument', 'documentId', documentId)
            const localVarPath = `/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a document passage explorer by its unique identifier
         * @summary Get a document passage explorer
         * @param {string} documentId 
         * @param {string} passageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentPassageExplorer: async (documentId: string, passageKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getDocumentPassageExplorer', 'documentId', documentId)
            // verify required parameter 'passageKey' is not null or undefined
            assertParamExists('getDocumentPassageExplorer', 'passageKey', passageKey)
            const localVarPath = `/documents/{documentId}/passages/{passageKey}/explorer`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"passageKey"}}`, encodeURIComponent(String(passageKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of documents based on a search query
         * @summary Autocomplete search suggester
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsAutocomplete: async (query: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('getDocumentsAutocomplete', 'query', query)
            const localVarPath = `/documents/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a document by its unique identifier
         * @summary Get a document by ID
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocument(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocument(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a document passage explorer by its unique identifier
         * @summary Get a document passage explorer
         * @param {string} documentId 
         * @param {string} passageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentPassageExplorer(documentId: string, passageKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseDocumentPassageExplorer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentPassageExplorer(documentId, passageKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentPassageExplorer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of documents based on a search query
         * @summary Autocomplete search suggester
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentsAutocomplete(query: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDocumentsAutocomplete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentsAutocomplete(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentsAutocomplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * Get a document by its unique identifier
         * @summary Get a document by ID
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(documentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.getDocument(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a document passage explorer by its unique identifier
         * @summary Get a document passage explorer
         * @param {string} documentId 
         * @param {string} passageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentPassageExplorer(documentId: string, passageKey: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseDocumentPassageExplorer> {
            return localVarFp.getDocumentPassageExplorer(documentId, passageKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of documents based on a search query
         * @summary Autocomplete search suggester
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsAutocomplete(query: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDocumentsAutocomplete200Response> {
            return localVarFp.getDocumentsAutocomplete(query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * Get a document by its unique identifier
     * @summary Get a document by ID
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocument(documentId: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocument(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a document passage explorer by its unique identifier
     * @summary Get a document passage explorer
     * @param {string} documentId 
     * @param {string} passageKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentPassageExplorer(documentId: string, passageKey: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentPassageExplorer(documentId, passageKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of documents based on a search query
     * @summary Autocomplete search suggester
     * @param {string} query 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentsAutocomplete(query: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentsAutocomplete(query, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeatureFlagsApi - axios parameter creator
 * @export
 */
export const FeatureFlagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the current feature settings, including message feedback and chat models.
         * @summary Get feature flags and settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureFlags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureFlagsApi - functional programming interface
 * @export
 */
export const FeatureFlagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureFlagsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the current feature settings, including message feedback and chat models.
         * @summary Get feature flags and settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureFlags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFeatureSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureFlags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.getFeatureFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeatureFlagsApi - factory interface
 * @export
 */
export const FeatureFlagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureFlagsApiFp(configuration)
    return {
        /**
         * Returns the current feature settings, including message feedback and chat models.
         * @summary Get feature flags and settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureFlags(options?: RawAxiosRequestConfig): AxiosPromise<ResponseFeatureSettings> {
            return localVarFp.getFeatureFlags(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureFlagsApi - object-oriented interface
 * @export
 * @class FeatureFlagsApi
 * @extends {BaseAPI}
 */
export class FeatureFlagsApi extends BaseAPI {
    /**
     * Returns the current feature settings, including message feedback and chat models.
     * @summary Get feature flags and settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    public getFeatureFlags(options?: RawAxiosRequestConfig) {
        return FeatureFlagsApiFp(this.configuration).getFeatureFlags(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessagesApi - axios parameter creator
 * @export
 */
export const MessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Submit message feedback
         * @param {RequestMessageFeedback} requestMessageFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMessageFeedback: async (requestMessageFeedback: RequestMessageFeedback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestMessageFeedback' is not null or undefined
            assertParamExists('addMessageFeedback', 'requestMessageFeedback', requestMessageFeedback)
            const localVarPath = `/message-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestMessageFeedback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new chat
         * @param {RequestCreateMessage} requestCreateMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChat: async (requestCreateMessage: RequestCreateMessage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestCreateMessage' is not null or undefined
            assertParamExists('createChat', 'requestCreateMessage', requestCreateMessage)
            const localVarPath = `/chats/new/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestCreateMessage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a message
         * @param {string} chatId 
         * @param {RequestCreateMessage} requestCreateMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessage: async (chatId: string, requestCreateMessage: RequestCreateMessage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('createMessage', 'chatId', chatId)
            // verify required parameter 'requestCreateMessage' is not null or undefined
            assertParamExists('createMessage', 'requestCreateMessage', requestCreateMessage)
            const localVarPath = `/chats/{chatId}/messages`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestCreateMessage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a message by ID
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage: async (chatId: string, messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('getMessage', 'chatId', chatId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getMessage', 'messageId', messageId)
            const localVarPath = `/chats/{chatId}/messages/{messageId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of all messages in a chat
         * @summary List messages
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessages: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('listMessages', 'chatId', chatId)
            const localVarPath = `/chats/{chatId}/messages`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stop answer generation for a message
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopMessageGeneration: async (chatId: string, messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('stopMessageGeneration', 'chatId', chatId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('stopMessageGeneration', 'messageId', messageId)
            const localVarPath = `/chats/{chatId}/messages/{messageId}/stop`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagesApi - functional programming interface
 * @export
 */
export const MessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Submit message feedback
         * @param {RequestMessageFeedback} requestMessageFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMessageFeedback(requestMessageFeedback: RequestMessageFeedback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMessageFeedback(requestMessageFeedback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.addMessageFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new chat
         * @param {RequestCreateMessage} requestCreateMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChat(requestCreateMessage: RequestCreateMessage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessagePair>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChat(requestCreateMessage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.createChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a message
         * @param {string} chatId 
         * @param {RequestCreateMessage} requestCreateMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMessage(chatId: string, requestCreateMessage: RequestCreateMessage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessagePair>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMessage(chatId, requestCreateMessage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.createMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a message by ID
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessage(chatId: string, messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessage(chatId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.getMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of all messages in a chat
         * @summary List messages
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMessages(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessageArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMessages(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.listMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stop answer generation for a message
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopMessageGeneration(chatId: string, messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopMessageGeneration(chatId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.stopMessageGeneration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessagesApi - factory interface
 * @export
 */
export const MessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Submit message feedback
         * @param {RequestMessageFeedback} requestMessageFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMessageFeedback(requestMessageFeedback: RequestMessageFeedback, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addMessageFeedback(requestMessageFeedback, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new chat
         * @param {RequestCreateMessage} requestCreateMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChat(requestCreateMessage: RequestCreateMessage, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessagePair> {
            return localVarFp.createChat(requestCreateMessage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a message
         * @param {string} chatId 
         * @param {RequestCreateMessage} requestCreateMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessage(chatId: string, requestCreateMessage: RequestCreateMessage, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessagePair> {
            return localVarFp.createMessage(chatId, requestCreateMessage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a message by ID
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage(chatId: string, messageId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.getMessage(chatId, messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of all messages in a chat
         * @summary List messages
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessages(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessageArray> {
            return localVarFp.listMessages(chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stop answer generation for a message
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopMessageGeneration(chatId: string, messageId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stopMessageGeneration(chatId, messageId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessagesApi - object-oriented interface
 * @export
 * @class MessagesApi
 * @extends {BaseAPI}
 */
export class MessagesApi extends BaseAPI {
    /**
     * 
     * @summary Submit message feedback
     * @param {RequestMessageFeedback} requestMessageFeedback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public addMessageFeedback(requestMessageFeedback: RequestMessageFeedback, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).addMessageFeedback(requestMessageFeedback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new chat
     * @param {RequestCreateMessage} requestCreateMessage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public createChat(requestCreateMessage: RequestCreateMessage, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).createChat(requestCreateMessage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a message
     * @param {string} chatId 
     * @param {RequestCreateMessage} requestCreateMessage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public createMessage(chatId: string, requestCreateMessage: RequestCreateMessage, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).createMessage(chatId, requestCreateMessage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a message by ID
     * @param {string} chatId 
     * @param {string} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public getMessage(chatId: string, messageId: string, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).getMessage(chatId, messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of all messages in a chat
     * @summary List messages
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public listMessages(chatId: string, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).listMessages(chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stop answer generation for a message
     * @param {string} chatId 
     * @param {string} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public stopMessageGeneration(chatId: string, messageId: string, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).stopMessageGeneration(chatId, messageId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SharedChatMessagesApi - axios parameter creator
 * @export
 */
export const SharedChatMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a list of all messages in a shared chat
         * @summary List shared chat messages
         * @param {string} sharedLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSharedChatMessages: async (sharedLinkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sharedLinkId' is not null or undefined
            assertParamExists('listSharedChatMessages', 'sharedLinkId', sharedLinkId)
            const localVarPath = `/shared-chats/{sharedLinkId}/messages`
                .replace(`{${"sharedLinkId"}}`, encodeURIComponent(String(sharedLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SharedChatMessagesApi - functional programming interface
 * @export
 */
export const SharedChatMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SharedChatMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a list of all messages in a shared chat
         * @summary List shared chat messages
         * @param {string} sharedLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSharedChatMessages(sharedLinkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessageArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSharedChatMessages(sharedLinkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SharedChatMessagesApi.listSharedChatMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SharedChatMessagesApi - factory interface
 * @export
 */
export const SharedChatMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SharedChatMessagesApiFp(configuration)
    return {
        /**
         * Get a list of all messages in a shared chat
         * @summary List shared chat messages
         * @param {string} sharedLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSharedChatMessages(sharedLinkId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessageArray> {
            return localVarFp.listSharedChatMessages(sharedLinkId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SharedChatMessagesApi - object-oriented interface
 * @export
 * @class SharedChatMessagesApi
 * @extends {BaseAPI}
 */
export class SharedChatMessagesApi extends BaseAPI {
    /**
     * Get a list of all messages in a shared chat
     * @summary List shared chat messages
     * @param {string} sharedLinkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedChatMessagesApi
     */
    public listSharedChatMessages(sharedLinkId: string, options?: RawAxiosRequestConfig) {
        return SharedChatMessagesApiFp(this.configuration).listSharedChatMessages(sharedLinkId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check reset password token
         * @param {RequestCheckResetPasswordToken} requestCheckResetPasswordToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkResetPasswordToken: async (requestCheckResetPasswordToken: RequestCheckResetPasswordToken, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestCheckResetPasswordToken' is not null or undefined
            assertParamExists('checkResetPasswordToken', 'requestCheckResetPasswordToken', requestCheckResetPasswordToken)
            const localVarPath = `/auth/password/reset/check-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestCheckResetPasswordToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a guest token pair
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGuestTokenPair: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/tokens/guest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchanges the authorization code for user credentials and returns a JWT token
         * @summary Finish Google OAuth2 flow
         * @param {RequestGoogleAuthFinish} requestGoogleAuthFinish 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishGoogleAuth: async (requestGoogleAuthFinish: RequestGoogleAuthFinish, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestGoogleAuthFinish' is not null or undefined
            assertParamExists('finishGoogleAuth', 'requestGoogleAuthFinish', requestGoogleAuthFinish)
            const localVarPath = `/auth/google/finish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestGoogleAuthFinish, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finish reset password
         * @param {RequestFinishResetPassword} requestFinishResetPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishResetPassword: async (requestFinishResetPassword: RequestFinishResetPassword, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestFinishResetPassword' is not null or undefined
            assertParamExists('finishResetPassword', 'requestFinishResetPassword', requestFinishResetPassword)
            const localVarPath = `/auth/password/reset/finish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestFinishResetPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh a token pair
         * @param {RequestRefreshToken} requestRefreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens: async (requestRefreshToken: RequestRefreshToken, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestRefreshToken' is not null or undefined
            assertParamExists('refreshTokens', 'requestRefreshToken', requestRefreshToken)
            const localVarPath = `/auth/tokens/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestRefreshToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset password
         * @param {RequestResetPassword} requestResetPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (requestResetPassword: RequestResetPassword, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestResetPassword' is not null or undefined
            assertParamExists('resetPassword', 'requestResetPassword', requestResetPassword)
            const localVarPath = `/auth/password/reset/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestResetPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sign in
         * @param {RequestPasswordSignIn} requestPasswordSignIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithPassword: async (requestPasswordSignIn: RequestPasswordSignIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPasswordSignIn' is not null or undefined
            assertParamExists('signInWithPassword', 'requestPasswordSignIn', requestPasswordSignIn)
            const localVarPath = `/auth/password/signin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPasswordSignIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates the Google OAuth2 PKCE flow and returns the authorization URL
         * @summary Start Google OAuth2 flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startGoogleAuth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/google/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check reset password token
         * @param {RequestCheckResetPasswordToken} requestCheckResetPasswordToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkResetPasswordToken(requestCheckResetPasswordToken: RequestCheckResetPasswordToken, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCheckResetPasswordToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkResetPasswordToken(requestCheckResetPasswordToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.checkResetPasswordToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a guest token pair
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGuestTokenPair(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAuthenticatedUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGuestTokenPair(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.createGuestTokenPair']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchanges the authorization code for user credentials and returns a JWT token
         * @summary Finish Google OAuth2 flow
         * @param {RequestGoogleAuthFinish} requestGoogleAuthFinish 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishGoogleAuth(requestGoogleAuthFinish: RequestGoogleAuthFinish, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGoogleAuthFinish>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishGoogleAuth(requestGoogleAuthFinish, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.finishGoogleAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Finish reset password
         * @param {RequestFinishResetPassword} requestFinishResetPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishResetPassword(requestFinishResetPassword: RequestFinishResetPassword, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishResetPassword(requestFinishResetPassword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.finishResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh a token pair
         * @param {RequestRefreshToken} requestRefreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshTokens(requestRefreshToken: RequestRefreshToken, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRefreshToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshTokens(requestRefreshToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.refreshTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset password
         * @param {RequestResetPassword} requestResetPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(requestResetPassword: RequestResetPassword, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(requestResetPassword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sign in
         * @param {RequestPasswordSignIn} requestPasswordSignIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signInWithPassword(requestPasswordSignIn: RequestPasswordSignIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAuthenticatedUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signInWithPassword(requestPasswordSignIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.signInWithPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates the Google OAuth2 PKCE flow and returns the authorization URL
         * @summary Start Google OAuth2 flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startGoogleAuth(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGoogleAuthStart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startGoogleAuth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.startGoogleAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Check reset password token
         * @param {RequestCheckResetPasswordToken} requestCheckResetPasswordToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkResetPasswordToken(requestCheckResetPasswordToken: RequestCheckResetPasswordToken, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCheckResetPasswordToken> {
            return localVarFp.checkResetPasswordToken(requestCheckResetPasswordToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a guest token pair
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGuestTokenPair(options?: RawAxiosRequestConfig): AxiosPromise<ResponseAuthenticatedUser> {
            return localVarFp.createGuestTokenPair(options).then((request) => request(axios, basePath));
        },
        /**
         * Exchanges the authorization code for user credentials and returns a JWT token
         * @summary Finish Google OAuth2 flow
         * @param {RequestGoogleAuthFinish} requestGoogleAuthFinish 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishGoogleAuth(requestGoogleAuthFinish: RequestGoogleAuthFinish, options?: RawAxiosRequestConfig): AxiosPromise<ResponseGoogleAuthFinish> {
            return localVarFp.finishGoogleAuth(requestGoogleAuthFinish, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finish reset password
         * @param {RequestFinishResetPassword} requestFinishResetPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishResetPassword(requestFinishResetPassword: RequestFinishResetPassword, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.finishResetPassword(requestFinishResetPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<CurrentUser> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh a token pair
         * @param {RequestRefreshToken} requestRefreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens(requestRefreshToken: RequestRefreshToken, options?: RawAxiosRequestConfig): AxiosPromise<ResponseRefreshToken> {
            return localVarFp.refreshTokens(requestRefreshToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset password
         * @param {RequestResetPassword} requestResetPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(requestResetPassword: RequestResetPassword, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetPassword(requestResetPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sign in
         * @param {RequestPasswordSignIn} requestPasswordSignIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithPassword(requestPasswordSignIn: RequestPasswordSignIn, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAuthenticatedUser> {
            return localVarFp.signInWithPassword(requestPasswordSignIn, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates the Google OAuth2 PKCE flow and returns the authorization URL
         * @summary Start Google OAuth2 flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startGoogleAuth(options?: RawAxiosRequestConfig): AxiosPromise<ResponseGoogleAuthStart> {
            return localVarFp.startGoogleAuth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Check reset password token
     * @param {RequestCheckResetPasswordToken} requestCheckResetPasswordToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public checkResetPasswordToken(requestCheckResetPasswordToken: RequestCheckResetPasswordToken, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).checkResetPasswordToken(requestCheckResetPasswordToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a guest token pair
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public createGuestTokenPair(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).createGuestTokenPair(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchanges the authorization code for user credentials and returns a JWT token
     * @summary Finish Google OAuth2 flow
     * @param {RequestGoogleAuthFinish} requestGoogleAuthFinish 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public finishGoogleAuth(requestGoogleAuthFinish: RequestGoogleAuthFinish, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).finishGoogleAuth(requestGoogleAuthFinish, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finish reset password
     * @param {RequestFinishResetPassword} requestFinishResetPassword 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public finishResetPassword(requestFinishResetPassword: RequestFinishResetPassword, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).finishResetPassword(requestFinishResetPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh a token pair
     * @param {RequestRefreshToken} requestRefreshToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public refreshTokens(requestRefreshToken: RequestRefreshToken, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).refreshTokens(requestRefreshToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset password
     * @param {RequestResetPassword} requestResetPassword 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public resetPassword(requestResetPassword: RequestResetPassword, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).resetPassword(requestResetPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sign in
     * @param {RequestPasswordSignIn} requestPasswordSignIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public signInWithPassword(requestPasswordSignIn: RequestPasswordSignIn, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).signInWithPassword(requestPasswordSignIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates the Google OAuth2 PKCE flow and returns the authorization URL
     * @summary Start Google OAuth2 flow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public startGoogleAuth(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).startGoogleAuth(options).then((request) => request(this.axios, this.basePath));
    }
}



